import { isoZ, z } from 'my-zod'

export const polarisUsersModel = z.object({
  id: z.number(),
  firstName: z.string().nullable(),
  lastName: z.string().nullable(),
  email: z.string(),
  lastModifiedDate: isoZ.instant().nullable(),
  deletedDate: isoZ.instant().nullable(),
  serverLastModifiedDate: isoZ.instant().nullable(),
  roles: z.string().array().nullable(),
  teams: z.string().array().nullable()
})

export type polarisUsersModel = z.infer<typeof polarisUsersModel>

export const Roles = {
  AccountSpecialist: 'Account Specialist',
  Admin: 'Admin',
  AdventuresFleetManager: 'Adventures Fleet Manager',
  CorporateFleetManager: 'Corporate Fleet Manager',
  CorporateFleetAdmin: 'Corporate Fleet Admin',
  EmployeePolarisOwnedUnitManager: 'Employee Polaris Owned Unit Manager',
  RiskSpecialist: 'Risk Specialist',
  QuickSightReader: 'QuickSight Reader',
  VPNProd: 'VPN Prod',
  VPNProdReadReplica: 'VPN Prod Read Replica',
  VPNNonProd: 'VPN Non-Prod',
  ReportViewer: 'Report Viewer',
  WarehouseSpecialist: 'Warehouse Specialist',
  Finance: 'Finance',
  Operator: 'Operator',
  SalesRep: 'Sales Representative',
  SalesManager: 'Sales Manager',
  Developer: 'Developer',
  Member: 'Member',
  CustomerSupport: 'Customer Support',
  CatalogAdmin: 'Catalog Admin',
  UniversalLead: 'Universal Lead',
  CustomerSupportLead: 'Customer Support Lead',
  Manager: 'Manager',
  ServiceOps: 'Service Ops',
  PSSLegalENG: 'PSS-Legal-ENG',
  StripeAdmin: 'Stripe Admin',
  BusinessDevelopment: 'Business Development',
  FactoryDirectAdvantage_UofP: 'Factory Direct Advantage (University of Polaris)' // This role will be used to determine which users receive the University of Polaris Access Request emails but should have little to no access with Admin Web itself.
} as const

export type Role = (typeof Roles)[keyof typeof Roles]
export const RoleOptions = Object.values(Roles)

// This is a list of roles of people who are expected to be using Admin Web
// "day to day" and will have read access to most services.  This is distinguished
// from roles like VPNProd or QuickSightReader that just use our authentication system.
export const AdminWebRoles = [
  Roles.Admin,
  Roles.AccountSpecialist,
  Roles.Finance,
  Roles.AdventuresFleetManager,
  Roles.CorporateFleetAdmin,
  Roles.RiskSpecialist,
  Roles.ReportViewer,
  Roles.SalesManager,
  Roles.SalesRep,
  Roles.CustomerSupport,
  Roles.CatalogAdmin,
  Roles.UniversalLead,
  Roles.CustomerSupportLead,
  Roles.Manager,
  Roles.ServiceOps,
  Roles.StripeAdmin,
  Roles.BusinessDevelopment,
  Roles.FactoryDirectAdvantage_UofP
] as const

export const AdminWebRolesEnum = z.enum(AdminWebRoles)
